import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Mail, MapPin } from "lucide-react";
import { FOOTER_COLUMNS } from "./content/nav";
import { COMPANY } from "./content/site";

const SOCIAL = [
  { label: "LinkedIn", icon: Linkedin, href: "https://www.linkedin.com/in/techai-fortune-inc-b61230426/" },
  { label: "X / Twitter", icon: Twitter },
];

export default function Footer() {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="container mx-auto px-6 md:px-10 lg:px-16 py-16 lg:py-20 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="" className="h-11 w-11" />
            <div>
              <div className="font-display font-bold text-lg leading-none">{COMPANY.name}</div>
              <div className="eyebrow text-white/50 mt-1">{COMPANY.tagline}</div>
            </div>
          </div>
          <p className="mt-6 text-sm text-white/60 leading-relaxed max-w-sm">{COMPANY.positioning}. Technology consulting and workforce solutions for U.S. businesses — from data and AI to the people who run it.</p>
          <ul className="mt-6 space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-[#00D4FF]" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a></li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-[#00D4FF]" /><span>{COMPANY.legal}<br />{COMPANY.address[0]}<br />{COMPANY.address[1]}</span></li>
          </ul>
          <div className="mt-6 flex gap-2" aria-label="Social links">
            {SOCIAL.map(({ label, icon: I, href }) => href ? (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={`${label} (opens in new tab)`} data-testid={`social-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="h-10 w-10 grid place-items-center rounded-full bg-white/5 hover:bg-[#1A6EFF] transition-colors"><I className="h-4 w-4" /></a>
            ) : (
              <span key={label} aria-label={`${label} (coming soon)`} title="Coming soon" className="h-10 w-10 grid place-items-center rounded-full bg-white/5 text-white/40 cursor-default"><I className="h-4 w-4" /></span>
            ))}
          </div>
        </div>
        <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="eyebrow text-white/40 mb-4">{col.title}</div>
              <ul className="space-y-2.5 text-sm text-white/70">
                {col.links.map((l) => <li key={l.label}><Link to={l.to} className="hover:text-white transition-colors">{l.label}</Link></li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <div className="container mx-auto px-6 md:px-10 lg:px-16 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} {COMPANY.legal} All rights reserved.</div>
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <Link to="/accessibility" className="hover:text-white">Accessibility</Link>
            <Link to="/app" className="hover:text-white">Client Portal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
